import { createFileRoute } from '@tanstack/react-router'
import { ReportsSettingsScreen } from '../features/reports'
import { catalogueQuery } from '../features/reports/api'

export const Route = createFileRoute('/reports/settings')({
  // Warm the catalogue (it says whether I may edit); a failed read is the screen's banner, never a route error.
  loader: ({ context }) => void context.queryClient.prefetchQuery(catalogueQuery()),
  component: ReportsSettingsScreen,
})
